












































































































































































































































































































































import Vue from 'vue';
import EnemyDetail from '@/components/enemy/EnemyDetail.vue';
import EnemyTooltip from '@/components/enemy/EnemyTooltip.vue';
import Const, { CELL_TYPE, DIFFICULTY_LEVEL, FORMATION } from '@/classes/const';
import CellMaster from '@/classes/enemy/cellMaster';
import EnemyFleet from '@/classes/enemy/enemyFleet';
import EnemyMaster from '@/classes/enemy/enemyMaster';
import Enemy from '@/classes/enemy/enemy';
import ItemMaster from '@/classes/item/itemMaster';
import { MasterMap, MasterWorld } from '@/classes/interfaces/master';

export default Vue.extend({
  name: 'WorldList',
  components: {
    EnemyDetail,
    EnemyTooltip,
  },
  props: {
    handleSetEnemy: {
      type: Function,
    },
    handleSetFleets: {
      type: Function,
    },
    handleClose: {
      type: Function,
    },
  },
  data: () => ({
    tab: 'fleet0',
    formations: Const.FORMATIONS,
    allCells: [] as CellMaster[],
    world: 1,
    areas: [] as MasterMap[],
    area: 11,
    areaItems: [] as ({ divider: boolean } | { header: string } | { value: number; text: string; group: string })[],
    selectedArea: 11,
    level: DIFFICULTY_LEVEL.HARD,
    levelItems: Const.DIFFICULTY_LEVELS,
    cellIndex: 0,
    cellItems: [] as { text: string; value: number }[],
    imgMapItems: [] as CellMaster[],
    tabNames: [] as string[],
    fleetPatterns: [] as EnemyFleet[],
    isAirRaid: false,
    detailDialog: false,
    destroyDialog: false,
    selectedFleet: undefined as undefined | EnemyFleet,
    enabledCommitBtn: false,
    continuousMode: false,
    snackbar: false,
    unsubscribe: undefined as unknown,
    selectedNodeName: '',
    selectedNodeNames: [] as string[],
    expandMapDialog: false,
    hasBigMap: false,
    enabledTooltip: false,
    tooltipTimer: undefined as undefined | number,
    tooltipEnemy: new Enemy(),
    tooltipX: 0,
    tooltipY: 0,
  }),
  mounted() {
    // 敵編成読み込み
    const cells = this.$store.state.cells as CellMaster[];

    // 海域セレクトボックス初期化
    const items = [];
    const worlds = this.$store.state.worlds as MasterWorld[];
    const masterMaps = this.$store.state.maps as MasterMap[];
    for (let i = 0; i < worlds.length; i += 1) {
      const world = worlds[i];
      const maps = masterMaps.filter((v) => Math.floor(v.area / 10) === world.world);
      if (!maps.length) {
        continue;
      }
      if (i > 0) {
        items.push({ divider: true });
      }

      items.push({ header: world.name });
      for (let j = 0; j < maps.length; j += 1) {
        const map = maps[j];
        const worldText = world.world > 40 ? 'E' : `${world.world}`;
        items.push({ value: map.area, text: `${worldText}-${map.area % 10}：${map.name}`, group: world.name });
      }
    }
    this.areaItems = items;

    if (cells.length) {
      // マスタデータがあるならそれでOK
      this.initCells(cells);
      return;
    }

    // マスタデータ読み込み開始
    this.$store.dispatch('loadCellData');
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setCells') {
        this.initCells(state.cells);
      }
    });
  },
  computed: {
    rawLevel(): number {
      return [4, 3, 2, 1][this.level];
    },
    isEvent(): boolean {
      return Math.floor(this.area / 10) > 40;
    },
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      (this.unsubscribe as () => void)();
    }
  },
  methods: {
    initCells(cells: CellMaster[]) {
      for (let i = 0; i < cells.length; i += 1) {
        this.allCells.push(cells[i]);
      }
      this.worldChanged();
    },
    worldChanged() {
      // 海域-マップ統合セレクトより選択
      this.world = Math.floor(this.selectedArea / 10);
      this.area = this.selectedArea;

      const lv = this.rawLevel;
      const maps = this.$store.state.maps as MasterMap[];
      this.areas = maps.filter((v) => Math.floor(v.area / 10) === this.world);

      if (!this.areas.some((v) => v.area === this.area)) {
        this.area = this.areas[0] ? this.areas[0].area : 0;
      }
      this.hasBigMap = maps.some((v) => v.area === this.area && v.has_detail);

      // 該当するセルを取得
      const cells = this.allCells.filter((v) => v.area === this.area && (this.isEvent ? v.level === lv : true));
      const array: CellMaster[] = [];
      const cellItems: { text: string; value: number }[] = [];
      for (let i = 0; i < cells.length; i += 1) {
        const data = cells[i];
        const [x, y, ex, ey] = data.coords.split(',');
        const coords = ex && ey ? data.coords : `${x},${y},${+x + 20},${+y + 20}`;
        if (!cellItems.find((v) => v.text === data.node)) {
          data.coords = coords;
          array.push(data);
          cellItems.push({ text: data.node, value: cellItems.length });
        }
      }
      this.cellIndex = 0;
      if (this.tab !== 'fleet0') {
        this.tab = 'fleet0';
      }
      this.imgMapItems = array;

      // Air Raidをてっぺんに
      cellItems.sort((a, b) => {
        if (a.text === 'Air Raid' && b.text !== 'Air Raid') return -1;
        if (b.text === 'Air Raid' && a.text !== 'Air Raid') return 1;
        return 0;
      });
      this.cellItems = cellItems;
      this.cellChanged();
    },
    cellChanged() {
      this.cellClicked(this.cellIndex);
    },
    cellClicked(index: number) {
      this.cellIndex = index;
      if (this.tab !== 'fleet0') {
        this.tab = 'fleet0';
      }
      const enemiesMaster = this.$store.getters.getEnemies as EnemyMaster[];
      const items = this.$store.state.items as ItemMaster[];
      const clickedCell = this.imgMapItems[index];
      this.isAirRaid = false;
      if (!clickedCell) {
        this.fleetPatterns = [];
        this.tabNames = [];
        this.enabledCommitBtn = false;
        return;
      }
      const lv = this.rawLevel;

      let cells = this.allCells.filter((v) => v.area === clickedCell.area && v.node === clickedCell.node);
      if (this.isEvent) {
        cells = cells.filter((v) => v.level === lv);
      }
      const enemyFleets: EnemyFleet[] = [];
      const patternNames: string[] = [];
      for (let j = 0; j < cells.length; j += 1) {
        const cell = cells[j];
        const isUnion = cell.cellType === CELL_TYPE.GRAND;
        const cellEnemies = cell.enemies.map((v) => v + 1500);
        const enemies: Enemy[] = [];

        for (let i = 0; i < cellEnemies.length; i += 1) {
          const id = cellEnemies[i];
          enemies.push(Enemy.createEnemyFromMasterId(id, isUnion && i >= 6, enemiesMaster, items));
        }

        // 味方陣形 => 空襲のとき輪形
        const isAirRaid = cell.cellType === CELL_TYPE.AIR_RAID
          || cell.cellType === CELL_TYPE.HIGH_AIR_RAID
          || cell.cellType === CELL_TYPE.SUPER_HIGH_AIR_RAID;
        this.isAirRaid = isAirRaid;
        const mainFleetFormation = isAirRaid ? FORMATION.DIAMOND : FORMATION.LINE_AHEAD;

        enemyFleets.push(
          new EnemyFleet({
            enemies,
            formation: cell.formation,
            cellType: cell.cellType,
            range: cell.radius,
            area: cell.area,
            nodeName: clickedCell.node,
            mainFleetFormation,
          }),
        );
        patternNames.push(cell.detail ? cell.detail : `Fleet ${j + 1}`);
      }

      this.fleetPatterns = enemyFleets;
      this.tabNames = patternNames;
      if (this.fleetPatterns.length > 0) {
        this.selectedFleet = enemyFleets[enemyFleets.length - enemyFleets.length];
        this.enabledCommitBtn = true;
        this.selectedNodeName = clickedCell.node;
      } else {
        this.selectedFleet = undefined;
        this.enabledCommitBtn = false;
      }
    },
    getFormationName(i: number) {
      const formation = Const.FORMATIONS.find((v) => v.value === i);
      return formation ? formation.text : '';
    },
    getCellName(i: number) {
      const cell = Const.CELL_TYPES.find((v) => v.value === i);
      return cell ? cell.text : '';
    },
    showEnemyFleetDetail() {
      this.detailDialog = true;
      this.destroyDialog = false;
    },
    toggleDetailDialog() {
      if (!this.detailDialog) {
        setTimeout(() => {
          this.destroyDialog = true;
        }, 100);
      } else {
        this.destroyDialog = false;
      }
    },
    fleetTabChanged(value: string) {
      const index = +value.replaceAll('pattern', '');
      const fleet = this.fleetPatterns[index];

      if (fleet) {
        this.selectedFleet = fleet;
        this.enabledCommitBtn = true;
      } else {
        this.enabledCommitBtn = false;
        this.selectedFleet = undefined;
      }
    },
    commitFleet() {
      this.enabledCommitBtn = false;
      this.handleSetEnemy(this.selectedFleet, this.continuousMode);
      this.selectedNodeNames.push(this.selectedNodeName);
      this.selectedNodeName = '';

      if (this.continuousMode) {
        this.snackbar = true;
      }
    },
    expandMap() {
      this.expandMapDialog = true;
    },
    close() {
      this.handleClose();
    },
    closeDetail() {
      this.detailDialog = false;
    },
    bootTooltip(enemy: Enemy, e: MouseEvent) {
      if (!enemy.data.id) {
        return;
      }
      const nameDiv = (e.target as HTMLDivElement).getElementsByClassName('text-id')[0] as HTMLDivElement;
      this.tooltipTimer = window.setTimeout(() => {
        const rect = nameDiv.getBoundingClientRect();
        this.tooltipX = e.clientX;
        this.tooltipY = rect.y + rect.height;
        this.tooltipEnemy = enemy;
        this.enabledTooltip = true;
      }, 400);
    },
    clearTooltip() {
      this.enabledTooltip = false;
      window.clearTimeout(this.tooltipTimer);
    },
  },
});
